import Animated, { FlipInEasyY } from 'react-native-reanimated';
import Loading from '../../../../Loading/Loading';
import { AnswerSelectPresentationProps } from '../../config';
import { FC } from 'react';
import { SingleSelectChoice } from './SingleSelectChoice';
import { View } from 'react-native';
import { observer } from 'mobx-react';
import { useStores } from '../../../../../hooks/useStores';

interface SingleSelectObserverProps {
  id: string;
  label: string;
  onPress: () => void;
  index?: number;
}
// this component exists because passing mobx state into FlatList.renderItem breaks observability
const SingleSelectChoiceObserver = observer(({
  id,
  label,
  onPress,
  index = 0,
}: SingleSelectObserverProps) => {
  const { treeNav } = useStores();
  return (
    <Animated.View
      entering={FlipInEasyY.duration((200 + index * 50))}
    >
      <SingleSelectChoice
        key={id}
        label={label}
        selected={!!treeNav.choices.pending?.answers.some(a => a.id === id)}
        onPress={onPress}
      />
    </Animated.View>
  );
});

const _PresentDefault : FC<AnswerSelectPresentationProps> = ({
  answers,
  onPress,
  loading,
}) => {
  if (loading) {
    return <Loading />;
  }
  // Plain map, not a FlatList: this list renders inside the session ScrollView,
  // where a nested VirtualizedList both logs the dev warning and cannot actually
  // virtualize. Answer lists are a handful of items; the per-item FlipInEasyY
  // entering animation lives in SingleSelectChoiceObserver and is unchanged.
  return (
    <View>
      {(answers ?? []).map((item, index) => (
        <SingleSelectChoiceObserver
          key={item._id}
          id={item._id}
          label={item?.wording || ''}
          onPress={() => onPress(item)}
          index={index}
        />
      ))}
    </View>
  );
};
export const PresentDefault = observer(_PresentDefault);
